<div class="vbox mask-container">
  <div class="mat-h3 separator"><span class="label">Booking Info</span>{{piece.id}}</div>
  <div class="hbox">
    <app-display-value label="Forwarder" [value]="shipment.forwarder"></app-display-value>
    <app-display-value label="Destination" [value]="piece.flightArrival" size="small"></app-display-value>
    <app-display-value label="Flight No." [value]="piece.flightNo" size="small"></app-display-value>
    <app-display-value label="Carrier" [value]="piece.carrier" size="small"></app-display-value>
    <app-display-value label="Departure" [value]="piece.flightDepartureTime" size=""></app-display-value>
    <app-display-value label="LAT" [value]="piece.lat" size=""></app-display-value>

  </div>
  <div class="mat-h3 separator"><span class="label">Shipment Info</span></div>
  <div class="hbox">
    <app-display-value label="Master AWB" [value]="shipment.masterAwb"></app-display-value>
    <app-display-value label="House AWB" [value]="shipment.houseAwb"></app-display-value>

    <app-display-value label="Handl. Instructions" [value]="piece.handlingInstructions"></app-display-value>
    <app-display-value label="Marking" [value]="piece.otherIdentifier"></app-display-value>
    <app-display-value label="SPX-Status" [value]="piece.spxStatus" size="small"></app-display-value>
  </div>

  <div class="vbox">
    <div class="hbox-nowrap">
      <div class="vbox align-end">
        <app-display-value label="No. of Pieces" size="small" [value]="shipment.pieceCount"></app-display-value>
      </div>
      <div class="pieces-table">
        <app-pieces-table [otherPieces]="[piece]"></app-pieces-table>
      </div>
    </div>
  </div>

  <div class="mat-h3 separator"><span class="label">Warehouse Info</span></div>
  <div class="hbox">
    <app-display-value label="Warehouse Receipt" [value]="piece.warehouseReceipt"></app-display-value>
    <app-display-value label="Storage Location" [value]="piece.storageLocation"></app-display-value>
    <app-display-value label="Commodity" [value]="piece.commodity"></app-display-value>
    <app-display-value *ngIf="isCha()" label="ULD" [value]="piece.uldSerial"></app-display-value>
  </div>
</div>
